import React from 'react'
import { Team } from './styles'
import ShowCase from './ShowCase'
import Member from './Member'
import { SHOWCASE, TEAM } from './constants'

type Props = {
  showCase: boolean
}

const TradeTeam = ({ showCase }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const team = showCase ? TEAM : [SHOWCASE, ...TEAM].splice(0, 4)
  return (
    <Team data-type='team'>
      {showCase ? (
        <ShowCase data={SHOWCASE} />
      ) : (
        <h2 className='defaultTypographyH2' data-type='meet-team-title'>
          Meet Our Senior Advisory Team
        </h2>
      )}

      <div data-section='member-list'>
        {team.map((teamMember, index) => (
          <Member data={teamMember} key={index} />
        ))}
      </div>
    </Team>
  )
}

export default TradeTeam
